import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    assestmenttitleindicators:[]
}

export const fetchAssestmentTitleIndicator = createAsyncThunk('assestmenttitleindicator/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/assestmentTitleIndicator`)
    return response.data
  })


let userSlice = createSlice({
  name:'assestmenttitleindicator',//Root Reducer Name
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchAssestmentTitleIndicator.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchAssestmentTitleIndicator.fulfilled,(state,action)=>{
          state.isLoading = false
          state.assestmenttitleindicators = action.payload
      })
      .addCase(fetchAssestmentTitleIndicator.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;